import React, { useEffect, useState } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Filler,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import axios from "axios";
import ChartDataLabels from "chartjs-plugin-datalabels";


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    Filler,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const ExampleCoachingstat = ({ company }) => {

    const labels = ['10/2022', '11/2022', '12/2022', '1/2023', '2/2023', '3/2023', '4/2023', '5/2023', '6/2023', '7/2023', '8/2023', '9/2023', '10/2023']
    const responseData = [0, 0, 0, 0, 0, 1, 1, 0, 3, 2, 5, 3, 1]



    const data = {
        labels,
        datasets: [
            {
                fill: true,
                label: "Sold Appointment(s)",
                data: responseData,
                borderColor: "rgb(128, 179, 87)",
                borderWidth: 3,
                backgroundColor: "rgba(128, 179, 87, 0.3)",
            },
        ],
    };


    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            datalabels: {
                display: (context) => context.dataset.data[context.dataIndex] !== 0,
                align: "top", // You can adjust label alignment (top, center, bottom)
                color: "rgb(128,179,87)", // Label color
                font: {
                    weight: "bold", // Label font weight
                    size: 12
                },
            },
        },
    };

    return (
        <div>

            <div>
                <Line data={data} options={options} plugins={[ChartDataLabels]} />
            </div>
        </div>
    );
};

export default ExampleCoachingstat;
